import {
  collection,
  doc,
  getFirestore,
  serverTimestamp,
  updateDoc,
  writeBatch,
} from "@firebase/firestore";
import { getAuth } from "firebase/auth";

const firestore = getFirestore();

export async function checkInOut(studentData, isIn) {
  const auth = getAuth();
  const batch = writeBatch(firestore);

  const studentPartialRef = doc(firestore, "students_partial", studentData.admissionNo);
  batch.update(studentPartialRef, {
    isIn,
  });

  const inoutHistoryRef = doc(collection(firestore, "inout_history"));
  batch.set(inoutHistoryRef, {
    admissionNo: studentData.admissionNo,
    time: serverTimestamp(),
    isIn,
    doneBy: auth.currentUser.uid,
  });

  await batch.commit();
}
